var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import Draggable from 'react-draggable';

var pad2 = function pad2(number) {
  return number < 10 ? '0' + number : number;
};

var formatTiempo = function formatTiempo(segundos) {
  var separador = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";
  var mm = Math.trunc(segundos / 60);
  var ss = Math.trunc(segundos - mm * 60);
  return '' + pad2(mm) + separador + pad2(ss);
};

var MODO_CUENTA_ATRAS = 'cuenta-atras';
var MODO_CUENTA_ALANTE = 'cuenta-alante';
var MAX_TIEMPO = 99 * 60 + 59;
var INTERVAL = 250;
var INCREMENTO = INTERVAL / 1000;
var Crono = (_temp = _class = function (_React$Component) {
  _inherits(Crono, _React$Component);

  function Crono(props) {
    _classCallCheck(this, Crono);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleCuentaAlante = function () {
      var running = _this.state.running;
      !running && _this.setState({
        cuentaAtras: false
      });
    };

    _this.handleCuentaAtras = function () {
      var running = _this.state.running;
      !running && _this.setState({
        cuentaAtras: true
      });
    };

    _this.handleIncrementarMinutos = function () {
      var running = _this.state.running;
      !running && _this.incrementarTiempo(60);
    };

    _this.handleDecrementarMinutos = function () {
      var running = _this.state.running;
      !running && _this.incrementarTiempo(-60);
    };

    _this.handleIncrementarSegundos = function () {
      var running = _this.state.running;
      !running && _this.incrementarTiempo(1);
    };

    _this.handleDecrementarSegundos = function () {
      var running = _this.state.running;
      !running && _this.incrementarTiempo(-1);
    };

    _this.handleReset = function () {
      _this.stop();

      _this.setState({
        tiempo: 0
      });
    };

    _this.incrementarTiempo = function (valor) {
      var tiempo = _this.state.tiempo;
      tiempo = tiempo + valor;

      if (tiempo < 0) {
        _this.stop();

        _this.setState({
          tiempo: 0,
          separador: ':'
        });

        return;
      }

      if (tiempo > MAX_TIEMPO) {
        _this.stop();

        _this.setState({
          tiempo: MAX_TIEMPO,
          separador: ':'
        });

        return;
      }

      _this.setState({
        tiempo: tiempo
      });
    };

    _this.handleTick = function () {
      var _this$state = _this.state,
          cuentaAtras = _this$state.cuentaAtras,
          tiempo = _this$state.tiempo,
          tiempoAviso = _this$state.tiempoAviso;
      var incremento = (cuentaAtras ? -1 : 1) * INCREMENTO;

      _this.incrementarTiempo(incremento);

      if (cuentaAtras && tiempo < tiempoAviso) {
        if (tiempo > 0.5 && tiempo === Math.trunc(tiempo)) {
          _this.audioAviso.pause();

          _this.audioAviso.currentTime = 0;

          _this.audioAviso.play();
        }

        if (tiempo === 0) {
          _this.audioFinal.play();
        }
      }

      if (_this.state.separador === ':') {
        _this.setState({
          separador: ' '
        });
      } else {
        _this.setState({
          separador: ':'
        });
      }
    };

    _this.handleCerrar = function () {
      return _this.props.onCerrar();
    };

    _this.handleStartStop = function () {
      var running = _this.state.running;

      if (running) {
        _this.stop();
      } else {
        _this.start();
      }
    };

    _this.handleMover = function (e, data) {
      var x = data.x,
          y = data.y;

      _this.props.onMover(x, y);
    };

    _this.state = {
      cuentaAtras: props.modoInicial === MODO_CUENTA_ATRAS,
      tiempo: props.tiempoInicial,
      tiempoAviso: props.tiempoAviso,
      running: false,
      separador: ':'
    };
    _this.audioAviso = null;
    _this.audioFinal = null;
    return _this;
  }

  Crono.prototype.stop = function stop() {
    var running = this.state.running;

    if (running === null) {
      return;
    }

    window.clearInterval(running);
    this.setState({
      running: null
    });
  };

  Crono.prototype.start = function start() {
    var running = window.setInterval(this.handleTick, INTERVAL);
    var cuentaAtras = this.state.cuentaAtras;

    if (cuentaAtras) {
      var _props = this.props,
          audioAviso = _props.audioAviso,
          audioFinal = _props.audioFinal;
      this.audioAviso = new Audio();
      this.audioAviso.src = audioAviso;
      this.audioAviso.load();
      this.audioFinal = new Audio();
      this.audioFinal.src = audioFinal;
      this.audioFinal.load();
    }

    this.setState({
      running: running
    });
  };

  Crono.prototype.render = function render() {
    if (!this.props.visible) {
      return null;
    }

    var _props2 = this.props,
        x = _props2.x,
        y = _props2.y,
        textoStart = _props2.textoStart,
        textoStop = _props2.textoStop,
        textoReset = _props2.textoReset,
        textoCuentaAlante = _props2.textoCuentaAlante,
        textoCuentaAtras = _props2.textoCuentaAtras;
    var _state = this.state,
        tiempo = _state.tiempo,
        tiempoAviso = _state.tiempoAviso,
        running = _state.running,
        separador = _state.separador,
        cuentaAtras = _state.cuentaAtras;
    var textoContador = formatTiempo(tiempo, running ? separador : ':');
    return React.createElement(Draggable, {
      bounds: 'body',
      handle: '.cabeceraCrono',
      onStop: this.handleMover,
      defaultPosition: {
        x: x,
        y: y
      }
    }, React.createElement('div', {
      className: 'crono',
      style: {
        left: 0,
        top: 0,
        zIndex: 1000
      }
    }, React.createElement('div', {
      className: 'cabeceraCrono'
    }, React.createElement('div', {
      className: 'cerrarCrono',
      onClick: this.handleCerrar
    }, 'X')), React.createElement('div', {
      className: 'controlesCrono'
    }, React.createElement('div', {
      className: '' + (running ? 'desactivado' : '') + (!cuentaAtras ? ' activa' : ''),
      onClick: this.handleCuentaAlante
    }, textoCuentaAlante), React.createElement('div', {
      className: '' + (running ? 'desactivado' : '') + (cuentaAtras ? ' activa' : ''),
      onClick: this.handleCuentaAtras
    }, textoCuentaAtras)), React.createElement('div', {
      className: 'relojCrono'
    }, React.createElement('div', {
      className: 'ajustesCrono'
    }, !running && React.createElement('div', {
      className: 'masTiempo',
      onClick: this.handleIncrementarMinutos
    }, '+'), !running && React.createElement('div', {
      className: 'menosTiempo',
      onClick: this.handleDecrementarMinutos,
      style: {
        opacity: running ? 0 : 1
      }
    }, '-')), React.createElement('div', {
      className: 'contadorCrono',
      style: running && cuentaAtras && tiempo <= tiempoAviso ? {
        color: 'red'
      } : {}
    }, textoContador), React.createElement('div', {
      className: 'ajustesCrono'
    }, !running && React.createElement('div', {
      className: 'masTiempo',
      onClick: this.handleIncrementarSegundos,
      style: {
        opacity: running ? 0 : 1
      }
    }, '+'), !running && React.createElement('div', {
      className: 'menosTiempo',
      onClick: this.handleDecrementarSegundos,
      style: {
        opacity: running ? 0 : 1
      }
    }, '-'))), React.createElement('div', {
      className: 'controlesCrono'
    }, React.createElement('div', {
      onClick: this.handleStartStop
    }, running ? textoStop : textoStart), React.createElement('div', {
      onClick: this.handleReset
    }, textoReset))));
  };

  return Crono;
}(React.Component), _class.defaultProps = {
  modoInicial: MODO_CUENTA_ALANTE,
  tiempoInicial: 0,
  tiempoAviso: 3.5
}, _temp);
Crono.propTypes = process.env.NODE_ENV !== "production" ? {
  visible: t.bool.isRequired,
  x: t.number.isRequired,
  y: t.number.isRequired,
  audioAviso: t.string.isRequired,
  audioFinal: t.string.isRequired,
  textoStart: t.string.isRequired,
  textoStop: t.string.isRequired,
  textoReset: t.string.isRequired,
  textoCuentaAlante: t.string.isRequired,
  textoCuentaAtras: t.string.isRequired,
  modoInicial: t.string,
  tiempoInicial: t.number,
  tiempoAviso: t.number,
  onCerrar: t.func.isRequired,
  onMover: t.func.isRequired
} : {};
export default Crono;